import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const socialLinks = [
    { name: "Twitter", icon: "bi-twitter", url: "#" },
    { name: "Facebook", icon: "bi-facebook", url: "#" },
    { name: "Instagram", icon: "bi-instagram", url: "#" },
    { name: "Pinterest", icon: "bi-pinterest", url: "#" },
    { name: "Vimeo", icon: "bi-vimeo", url: "#" },
  ];

  const quickLinks = [
    { name: "Categories", to: "/categories", icon: "bi-grid" },
    { name: "Home", to: "/", icon: "bi-house" },
    { name: "Our Blog", to: "/blog", icon: "bi-journal-text" },
  ];

  const resourceLinks = [
    { name: "Become an Affiliate", to: "/affiliate", icon: "bi-cash-coin" },
    { name: "Feedback", to: "/feedback", icon: "bi-chat" },
    { name: "Help", to: "/help", icon: "bi-question-circle" },
    { name: "Contact us", to: "/contact", icon: "bi-envelope" },
  ];

  const aboutLinks = [
    { name: "Company", to: "/company", icon: "bi-building" },
    { name: "Terms of service", to: "/terms", icon: "bi-file-text" },
    { name: "Privacy policy", to: "/privacy", icon: "bi-shield" },
  ];

  return (
    <footer className="bg-dark text-white">
      {/* Main Footer Content */}
      <div className="container py-5">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
          {/* Logo and Description */}
          <div className="col">
            <div className="mb-4">
              <img
                src="/images/logo.png"
                alt="XL in English Logo"
                width="180"
                className="img-fluid"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div className="d-none fs-2 fw-bold text-inchworm">
                XL in English
              </div>
            </div>
            <p className="text-light mb-4 opacity-75">
              Empowering learners with comprehensive Math education resources
              and innovative learning solutions.
            </p>
            <div className="d-flex gap-3">
              {socialLinks.map(({ name, icon, url }) => (
                <a
                  key={name}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-inchworm text-decoration-none d-flex align-items-center justify-content-center rounded-circle bg-inchworm-20"
                  style={{ width: "40px", height: "40px" }}
                  title={name}
                >
                  <i className={`bi ${icon} fs-5`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col">
            <h6 className="fw-semibold text-inchworm mb-4">Quick Links</h6>
            <ul className="list-unstyled">
              {quickLinks.map((link) => (
                <li key={link.name} className="mb-2">
                  <Link
                    to={link.to}
                    className="text-light text-decoration-none opacity-75 hover-opacity-100 d-flex align-items-center"
                  >
                    <i className={`bi ${link.icon} me-2`}></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="col">
            <h6 className="fw-semibold text-inchworm mb-4">Resources</h6>
            <ul className="list-unstyled">
              {resourceLinks.map((link) => (
                <li key={link.name} className="mb-2">
                  <Link
                    to={link.to}
                    className="text-light text-decoration-none opacity-75 hover-opacity-100 d-flex align-items-center"
                  >
                    <i className={`bi ${link.icon} me-2`}></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div className="col">
            <h6 className="fw-semibold text-inchworm mb-4">About</h6>
            <ul className="list-unstyled">
              {aboutLinks.map((link) => (
                <li key={link.name} className="mb-2">
                  <Link
                    to={link.to}
                    className="text-light text-decoration-none opacity-75 hover-opacity-100 d-flex align-items-center"
                  >
                    <i className={`bi ${link.icon} me-2`}></i>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-dark-dark py-4 border-top border-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              <p className="text-light opacity-75 mb-0">
                © {new Date().getFullYear()} XL in English. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <span className="text-light opacity-75">
                Made with <i className="bi bi-heart-fill text-danger"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
